export const riceProducts = [
    {
        id: 1,
        name: "Basmati Rice Premium",
        price: 180,
        originalPrice: 220,
        discount: 18,
        image: "https://images.unsplash.com/photo-1586201375761-83865001e31c?w=500",
        category: "Basmati",
        stock: 50,
        description: "Premium quality aged Basmati rice with extra long grains and aromatic fragrance. Perfect for biryanis and pulao.",
        features: ["Extra Long Grain", "Aged 2 Years", "Premium Quality", "Aromatic"],
        weight: "1kg",
        origin: "Punjab, India"
    },
    {
        id: 2,
        name: "Jasmine Rice",
        price: 150,
        originalPrice: 180,
        discount: 17,
        image: "https://images.unsplash.com/photo-1596797038530-2c107229654b?w=500",
        category: "Jasmine",
        stock: 30,
        description: "Fragrant Thai Jasmine rice with soft texture and subtle floral aroma. Ideal for Asian cuisine.",
        features: ["Soft Texture", "Floral Aroma", "Thai Origin", "Premium Grade"],
        weight: "1kg",
        origin: "Thailand"
    },
    {
        id: 3,
        name: "Brown Rice Organic",
        price: 120,
        originalPrice: 140,
        discount: 14,
        image: "https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=500",
        category: "Brown",
        stock: 25,
        description: "Nutritious organic brown rice rich in fiber and minerals. Perfect for health-conscious consumers.",
        features: ["Organic Certified", "High Fiber", "Nutrient Rich", "Unpolished"],
        weight: "1kg",
        origin: "Karnataka, India"
    },
    {
        id: 4,
        name: "Sona Masoori Rice",
        price: 90,
        originalPrice: 110,
        discount: 18,
        image: "https://images.unsplash.com/photo-1550989460-0adf9ea622e2?w=500",
        category: "Sona Masoori",
        stock: 40,
        description: "Traditional South Indian rice variety with medium grain size. Perfect for daily meals and South Indian dishes.",
        features: ["Medium Grain", "Low Starch", "Traditional Variety", "Daily Use"],
        weight: "1kg",
        origin: "Andhra Pradesh, India"
    },
    {
        id: 5,
        name: "Red Rice Kerala",
        price: 160,
        originalPrice: 190,
        discount: 16,
        image: "https://images.unsplash.com/photo-1536304993881-ff6e9eefa2a6?w=500",
        category: "Red Rice",
        stock: 20,
        description: "Nutritious red rice from Kerala with rich antioxidants and unique nutty flavor.",
        features: ["Antioxidant Rich", "Nutty Flavor", "Traditional Kerala", "Unpolished"],
        weight: "1kg",
        origin: "Kerala, India"
    },
    {
        id: 6,
        name: "Black Rice Forbidden",
        price: 280,
        originalPrice: 320,
        discount: 13,
        image: "https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=500",
        category: "Black Rice",
        stock: 15,
        description: "Exotic black rice with high antioxidants and protein content. Known as forbidden rice in ancient times.",
        features: ["High Antioxidants", "High Protein", "Exotic Variety", "Premium Quality"],
        weight: "1kg",
        origin: "Manipur, India"
    }
]

export const categories = [
    "All",
    "Basmati",
    "Jasmine",
    "Brown",
    "Sona Masoori",
    "Red Rice",
    "Black Rice"
]